// CSS-only SOC donut ring using conic-gradient
interface SOCDonutProps {
  soc: number | null | undefined;
  size?: number;
  label?: string;
}

function getSOCColor(soc: number): string {
  if (soc < 10) return '#fb7185'; // ems-red
  if (soc < 20) return '#fbbf24'; // ems-amber
  return '#34d399'; // ems-green
}

export function SOCDonut({ soc, size = 100, label }: SOCDonutProps) {
  const safeSoc = soc ?? 0;
  const color = getSOCColor(safeSoc);
  const trackColor = '#0d1520'; // ems-bg
  const angle = (safeSoc / 100) * 360;

  return (
    <div className="flex flex-col items-center gap-1.5">
      <div
        className="relative rounded-full flex items-center justify-center"
        style={{
          width: size,
          height: size,
          background: `conic-gradient(${color} 0deg, ${color} ${angle}deg, ${trackColor} ${angle}deg, ${trackColor} 360deg)`,
        }}
      >
        {/* Inner cutout */}
        <div
          className="absolute rounded-full bg-ems-bg-card flex flex-col items-center justify-center"
          style={{
            width: size - 14,
            height: size - 14,
          }}
        >
          <span
            className="font-mono font-bold transition-all duration-300"
            style={{ color, fontSize: size > 80 ? '1.25rem' : '1rem' }}
          >
            {soc != null ? `${safeSoc.toFixed(0)}%` : '--'}
          </span>
          {label && (
            <span className="text-[9px] text-ems-text-muted uppercase tracking-wide">
              {label}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
